import { ChevronDown } from "lucide-react";
import { ReactNode, useState } from "react";
import { Badge } from "~/components/ui/badge";

interface FoldableBlockProps {
  title: string;
  children: ReactNode;
}

export function FoldableBlock({ title, children }: FoldableBlockProps) {
  const [openHotelServices, setOpenHotelServices] = useState(true);

  return (
    <div>
      <div
        className="bg-black text-white rounded-md flex justify-between px-3 py-2 cursor-pointer select-none"
        onClick={() => setOpenHotelServices((v) => !v)}
      >
        <div className="flex items-center gap-2">
          <ChevronDown
            className={`transition-transform duration-200 ${openHotelServices ? "rotate-0" : "-rotate-90"}`}
            size={24}
          />
          <h3 className="text-xl font-semibold">{title}</h3>
        </div>
      </div>
      {openHotelServices && (
        <div className="grid grid-cols-2 gap-4 min-h-[100px] bg-neutral-lightest mx-1.5 rounded-b-md p-4">
          {children}
        </div>
      )}
    </div>
  );
}
